import { useAuth } from "@/contexts/AuthContext";
import { useCreditBalance } from "@/hooks/useCreditBalance";
import { useCanReadSubscriptions, usePermissionsV2Loaded } from "@/permissions/v2";
import { useState } from "react";

import { CreditBalanceLoadingView } from "./CreditBalanceLoadingView";
import { CreditBalanceUpgradeView } from "./CreditBalanceUpgradeView";
import { CreditBalanceView } from "./CreditBalanceView";

export const CreditBalance = () => {
  const { creditBalance, isLoading } = useCreditBalance();
  const [showTooltip, setShowTooltip] = useState<boolean>(false);
  const { firmContext, isMyCases } = useAuth();
  const isPermissionsLoaded = usePermissionsV2Loaded();
  const canViewCreditBalance = useCanReadSubscriptions(firmContext?.firmId);

  if (isMyCases || !firmContext?.firmId || !isPermissionsLoaded || !canViewCreditBalance) {
    return null;
  }

  if (isLoading) {
    return <CreditBalanceLoadingView />;
  }

  if (!creditBalance?.success) {
    return <CreditBalanceUpgradeView />;
  }

  return (
    <CreditBalanceView
      showTooltip={showTooltip}
      included={creditBalance.included}
      used={creditBalance.used}
      maxLimit={creditBalance.max_limit}
      setShowTooltip={setShowTooltip}
    />
  );
};
